import { render, staticRenderFns } from "./EditContactDetailsDialog.vue?vue&type=template&id=0a15f95e&"
import script from "./EditContactDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditContactDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports